<template>
    <div class="block__rankingScore">

      <div class="left">
        <div class="title">
          {{titleLeft}}
        </div>
            <div class="bottom">
          <PuSkeleton :loading="isLoading" :count="1" width='40px' height="30px">          
                    <div class="increase" :class="getTheIncrease()">
                      <div v-if="getTheIncrease() == 'positif'">+</div>
                      <div v-if="getTheIncrease() == 'negatif'">-</div>
                      <div v-if="getTheIncrease() == 'equal'">=</div>
                      {{getTheIncrease() != 'equal' ? objectif : ''}}
                  </div>
                  <div class="objectifOf">
                  {{number}}
                    <span>/{{ofThem}}</span>
                  </div>        
          </PuSkeleton>
            </div>
      </div>

      <div class="right">
        <div class="title">
          {{titleRight}}
        </div>
          <PuSkeleton :loading="isLoading" :count="1" width='40px' height="30px">
            <p class="number">
                {{Math.round(scoreNumber)}}
            </p>
          </PuSkeleton>
      </div>
    </div>
</template>


<script>

import Utils from '../../Utils.js'

export default {
name:"wrapperRankingScore",
  props:{
    titleLeft:{
      default:'Classement'
      },
    titleRight:{
      default:'Score'
      },
    number:{
      },
    oldNumber:{
      },
    scoreNumber:{
      },
    ofThem:{
      },
    isLoad:{
      default: true
    }        
  },
  data(){
    return {
      isLoading:true,
      objectif:'1'
    }
  },
  created(){ 
    this.isLoading = this.isLoad;
  },
  methods:{
    getObjectif(){
      this.objectif = Utils.compare(this.number,this.oldNumber)
    },
    getTheIncrease(){
      return Utils.getTheClassCompare(this.number,this.oldNumber);
    }    
  },
  watch : {
    'isLoad' : function (){
      this.getObjectif();
      this.isLoading = this.isLoad;
    }
  }, 
}
</script>
